<div *ngIf="maInsurance">
    <div nxRow>
        <div nxCol="12">
            <h4 nxHeadline="subsection-small" class="nx-font-weight-light bordered" translate>ma-insurance.car.coverage
            </h4>
        </div>
    </div>

    <div nxRow>
        <div nxCol="12,12,12,6" class="tariff-item" *ngFor="let tariff of maInsurance.tariffList">
            <p><b translate>ma-insurance.tariff.scheme</b> {{ moduleNameByTarrif(tariff.tariff) }}</p>
            <p><b translate>ma-insurance.tariff.tariff</b> {{ tariff.tariff }}</p>
            <p><b translate>ma-insurance.tariff.rate</b> {{ tariff.rate|currencyFormat }}</p>
            <p><b translate>ma-insurance.tariff.zone</b> {{ tariff.zone }}</p>
        </div>
    </div>
</div>